import React from "react";
import { Dialog } from "@actinc/dls";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const WarningDialog = ({ message, onClose, title }) => {
  const handleClose = (value) => () => {
    onClose(value);
  };

  return (
    <Dialog maxWidth="sm" open={true} onClose={handleClose(false)}>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{!!message && <>{message}</>}</DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleClose(true)}
          color="primary"
          variant="text"
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { WarningDialog };
